import { css } from 'lit';
/* eslint-disable  */
if (!('randomUUID' in crypto)) {
	/* 
		* @see https://stackoverflow.com/a/2117523/2800218
	    * LICENSE: https://creativecommons.org/licenses/by-sa/4.0/legalcode
	*/
	(crypto as Crypto & { randomUUID: () => `${string}-${string}-${string}-${string}-${string}` }).
		randomUUID = function randomUUID() {
		// Polyfill relies on array-to-string coercion in `+` (legacy pattern).
		// @ts-expect-error — numeric/string coercion for UUID template
		return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: string) =>
			(
				Number(c) ^
				(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))
			).toString(16),
		);
	};
}
